import { render, staticRenderFns } from "./BotWeddingEventCreateModal.vue?vue&type=template&id=1e2d4e44"
import script from "./BotWeddingEventCreateModal.vue?vue&type=script&lang=ts"
export * from "./BotWeddingEventCreateModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports